import type { CollapseProps } from "antd";

import Info from "./Info";

export const DocCategoryContentConstants = {
	INFO: "Kategori Bilgileri",
};

export const DocCategoryItems: CollapseProps["items"] = [
	{
		key: "1",
		label: DocCategoryContentConstants.INFO,
		children: <Info />,
	}
];
